// src/components/ResumeBuilder/forms/ContactForm.jsx
import React, { useContext } from "react";
import { Box, Card, Grid, TextField, Typography } from "@mui/material";
import { Formik, Form } from "formik";
import { ContactSchema } from "./resumevalidation";
import GradientButton from "../Button";
import { ResumeContext } from "../../ResumeContext";
import { saveResumeData } from "../../api/resumeapi";
import BasicInfoSkeleton from "./skeletonLoader"; // reuse skeleton

export default function ContactForm({ onNext }) {
  const { data, setData, loading } = useContext(ResumeContext);
  console.log("ContactForm Resume Data:", data);

  // ✅ Skeleton while loading
  if (loading || !data) {
    return <BasicInfoSkeleton />;
  }

  return (
    <Card sx={{ p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography fontSize={13} color="#6E6D81" mb={2}>
        Share with us the best way to reach out to you!
      </Typography>

      <Formik
        enableReinitialize
        initialValues={{
          email: data?.email ?? "",
          phone: data?.phone ?? "",
          city: data?.city ?? "",
          country: data?.country ?? "",
        }}
        validationSchema={ContactSchema}
        onSubmit={async (values) => {
          const payload = {
            ...data,
            ...values,
          };

          try {
            // SAVE CONTACT DATA
            await saveResumeData(payload);

            // UPDATE CONTEXT (merge, don’t replace)
            setData((prev) => ({
              ...prev,
              ...values,
            }));
          } catch (err) {
            console.error("CONTACT SAVE ERROR:", err);
          }
        }}
      >
        {({ values, errors, touched, handleChange }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  size="small"
                  value={values.email}
                  onChange={handleChange}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  size="small"
                  value={values.phone}
                  onChange={handleChange}
                  error={touched.phone && Boolean(errors.phone)}
                  helperText={touched.phone && errors.phone}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  size="small"
                  value={values.city}
                  onChange={handleChange}
                  error={touched.city && Boolean(errors.city)}
                  helperText={touched.city && errors.city}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <TextField
                  fullWidth
                  label="Country"
                  name="country"
                  size="small"
                  value={values.country}
                  onChange={handleChange}
                  error={touched.country && Boolean(errors.country)}
                  helperText={touched.country && errors.country}
                />
              </Grid>
            </Grid>

            {/* BUTTONS */}
            <Box mt={3} display="flex" justifyContent="center" gap={4}>
              {/* NEXT: no submit */}
              <GradientButton
                type="button"
                onClick={onNext}
              >
                Next
              </GradientButton>

              {/* SAVE: submit */}
              <GradientButton type="submit">
                Save
              </GradientButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Card>
  );
}
